module.exports = __webpack_public_path__ + "img/img-fastfood-2.da2cebe9.jpg";